import React from "react";
import L001 from "../layouts/l001";
import L002 from "../layouts/l002";

const Components = {
  L001A: L001,
  L002A: L002,
  L002B: L002,
};

const Component = (
  block,
  layoutId,
  setLayoutIndex,
  layoutIndex,
  setExpand,
  fullScreen,
  setUserAuth,
  userAuth,
  token,
  setResetConfig,
  resetConfig,
  onResetStatus,
  setOnResetStatus
) => {
  if (block.layout === layoutId) {
    return React.createElement(Components[layoutId], {
      key: block.id,
      block: block,
      setLayoutIndex: setLayoutIndex,
      layoutIndex: layoutIndex,
      setExpand: setExpand,
      fullScreen: fullScreen,
      setUserAuth,
      userAuth,
      token,
      setResetConfig,
      resetConfig,
      onResetStatus,
      setOnResetStatus,
    });
  }
};
export default Component;
